// Initialize Google Analytics if tracking ID is provided
export function initializeGoogleAnalytics(): void {
	const trackingId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

	if (!trackingId) {
		console.warn('Google Analytics tracking ID not configured');
		return;
	}

	// Initialize dataLayer
	if (typeof window !== 'undefined') {
		window.dataLayer = window.dataLayer || [];
		
		// Define gtag function
		function gtag(...args: unknown[]): void {
			window.dataLayer.push(args);
		}

		// Make gtag available globally
		window.gtag = gtag;

		// Initialize Google Analytics
		gtag('js', new Date());
		gtag('config', trackingId);

		// Load Google Analytics script
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
		document.head.appendChild(script);
	}
}

